module.exports = __webpack_public_path__ + "img/HaoqinZhang.f1ff8c88.jpg";